import { cameraBannerProduct, carTracking1, enterpriseKit1, peopleTracking1, starterKit1 } from '@assets/images/main/camera';
import {
  productCardBleStarterM,
  productCardBleStarterD,
  productCardBleEnterpriseM,
  productCardBleEnterpriseD,
  productCardAoaStarterM,
  productCardAoaStarterD,
  productCardAoaEnterpriseM,
  productCardAoaEnterpriseD,
  productCardUwbStarterM,
  productCardUwbStarterD,
  productCardUwbEnterpriseM,
  productCardUwbEnterpriseD,
  productCardComfortM,
  productCardComfortD,
  productCardAiStarterM,
  productCardAiStarterD,
  productCardAiServerM,
  productCardAiServerD,
  productCardVehicleM,
  productCardVehicleD,
  productCardYardM,
  productCardYardD,
  productCardCameraM,
  productCardCameraD,
  productCardOutdoorM,
  productCardOutdoorD,
  productCardRtlsM,
  productCardRtlsD,
  productCardAccessM,
  productCardAccessD,
  productCardIotM,
  productCardIotD,
  productCardOrbroOsM,
} from '@assets/images/main/home/products/all';

import {
  aoaEnterpriseKit,
  aoaStarterKit,
  assetTracking1,
  bleEnterpriseKit,
  bleStarterKit,
  comfortKit1,
  uwbEnterpriseKit,
  uwbStarterKit,
  workerTracking1,
} from '@assets/images/main/rtls/product';
import { iotBannerProduct } from '@assets/images/main/sensor';

export default {
  assetPackage: {
    label: 'Assets Tracking Package',
    title: 'Asset Location Tracking Package',
    product: 'TwinTracker 10 + Server 1',
    desc: 'A product that helps track the real-time location by attaching BLE devices to workers or equipment.',
    img: assetTracking1,
    link: '/en/rtls',
    index: '1',
  },

  workerPackage: {
    label: 'Workers Tracking Package',
    title: 'Worker Location Tracking Package',
    product: 'TwinTrackerPro 10 + Server 1',
    desc: 'A product that helps track the real-time location by attaching UWB devices to workers or equipment.',
    img: workerTracking1,
    link: '/en/rtls',
    index: '2',
  },

  carPackage: {
    label: 'Vehicle Location Tracking Package',
    title: 'Vehicle Location Tracking Package',
    product: 'Server1 + NVR1 + PTZ Camera2',
    desc: 'Detect and manage the location and abnormal behavior of various objects such as people and vehicles through cameras.',
    img: carTracking1,
    link: '/en/camera',
    index: '1',
  },

  peoplePackage: {
    label: 'People Tracking and Analysis Package',
    title: 'Flowing Population Analysis Package',
    product: 'Server1 + NVR1 + IP Camera4',
    desc: 'The camera can analyze the movement path of indoor people and detect unexpected situations.',
    img: peopleTracking1,
    link: '/camera',
    index: '2',
  },

  recommand: 'Recommended Products',
  cards: [
    {
      title: 'TwinTracker BLE Starter Kit',
      desc: 'ORBRO Edge RTLS, L2 Switch, TwinTracker BLE (4 units)',
      link: '/rtls/ble',
      img: { desktop: productCardBleStarterD, tablet: productCardBleStarterM, mobile: productCardBleStarterM },
    },
    {
      title: 'BLE Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch (2 units), ORBRO Edge RTLS (2 units), TwinTracker BLE (12 units)',
      link: '/rtls/ble',
      img: { desktop: productCardBleEnterpriseD, tablet: productCardBleEnterpriseM, mobile: productCardBleEnterpriseM },
    },
    {
      title: 'TwinTracker AoA Starter Kit',
      desc: 'ORBRO Edge RTLS, L2 Switch, TwinTracker AoA (4 units)',
      link: '/rtls/aoa',
      img: { desktop: productCardAoaStarterD, tablet: productCardAoaStarterM, mobile: productCardAoaStarterM },
    },
    {
      title: 'AoA Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch (2 units), ORBRO Edge RTLS (2 units), TwinTracker AoA (12 units)',
      link: '/rtls/aoa',
      img: { desktop: productCardAoaEnterpriseD, tablet: productCardAoaEnterpriseM, mobile: productCardAoaEnterpriseM },
    },
    {
      title: 'TwinTracker UWB Starter Kit',
      desc: 'ORBRO Server, L2 Switch (2 units), ORBRO Edge RTLS (2 units), TwinTracker BLE (12 units)',
      link: '/rtls/uwb',
      img: { desktop: productCardUwbStarterD, tablet: productCardUwbStarterM, mobile: productCardUwbStarterM },
    },
    {
      title: 'UWB Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch (2 units), ORBRO Edge RTLS (2 units), TwinTracker UWB (12 units)',
      link: '/rtls/uwb',
      img: { desktop: productCardUwbEnterpriseD, tablet: productCardUwbEnterpriseM, mobile: productCardUwbEnterpriseM },
    },
    {
      title: 'Comfort Kit',
      desc: 'Mobile App, UWB Tag (8 units), UWB Tag',
      link: '/rtls/comfort',
      img: { desktop: productCardComfortD, tablet: productCardComfortM, mobile: productCardComfortM },
    },
    {
      title: 'ORBRO Edge AI Starter Kit',
      desc: 'ORBRO Edge AI, L2 Switch',
      link: '/camera/edge',
      img: { desktop: productCardAiStarterD, tablet: productCardAiStarterM, mobile: productCardAiStarterM },
    },
    {
      title: 'ORBRO AI Server Enterprise Kit',
      desc: 'ORBRO AI Server, ORBRO Server',
      link: '/camera/server',
      img: { desktop: productCardAiServerD, tablet: productCardAiServerM, mobile: productCardAiServerM },
    },
    {
      title: 'Vehicle Tracking Kit',
      desc: 'ORBRO Server x 1 + GPS Device x 5',
      link: '/outdoor/gps',
      img: { desktop: productCardVehicleD, tablet: productCardVehicleM, mobile: productCardVehicleM },
    },
    {
      title: 'Yard Tracking Kit',
      desc: 'ORBRO Server, LoRa Gateway, GPS Tag (10 units)',
      link: '/outdoor/lora',
      img: { desktop: productCardYardD, tablet: productCardYardM, mobile: productCardYardM },
    },
    {
      title: 'Video Tracking',
      desc: 'AI-based object tracking via video',
      link: '/camera',
      img: { desktop: productCardCameraD, tablet: productCardCameraM, mobile: productCardCameraM },
    },
    {
      title: 'Outdoor Tracking',
      desc: 'Vehicle and yard location tracking',
      link: '/outdoor',
      img: { desktop: productCardOutdoorD, tablet: productCardOutdoorM, mobile: productCardOutdoorM },
    },
    {
      title: 'RF Location Tracking',
      desc: 'Location tracking based on BLE, AoA, UWB wireless communication',
      link: '/rtls',
      img: { desktop: productCardRtlsD, tablet: productCardRtlsM, mobile: productCardRtlsM },
    },
    {
      title: 'Access Control System',
      desc: 'Automatic doors, facial recognition, and access management',
      link: '/access',
      img: { desktop: productCardAccessD, tablet: productCardAccessM, mobile: productCardAccessM },
    },
    {
      title: 'Industry IoT',
      desc: 'Integrate air quality, CO sensors, LoRa gateway, robots, and more',
      link: '/iot',
      img: { desktop: productCardIotD, tablet: productCardIotM, mobile: productCardIotM },
    },
    {
      type: 'orbroOs',
      title: 'ORBRO OS',
      desc: 'All Spaces, All Devices, Connected at a Glance on a Digital Platform',
      link: '/os',
      img: {
        desktop: productCardOrbroOsM,
        tablet: productCardOrbroOsM,
        mobile: productCardOrbroOsM,
      },
    },
  ],
};
